exports.onClientEntry = () => {
  // Ensure dataLayer exists for any code that runs before gtag loads
  if (typeof window !== 'undefined') {
    window['dataLayer'] = window['dataLayer'] || [];
    window['gtag'] = window['gtag'] || function () { window['dataLayer'].push(arguments); };
  }
};

exports.onRouteUpdate = ({ location }) => {
  // Only send page_view events in production to avoid polluting analytics during development
  if (typeof window === 'undefined' || process.env.NODE_ENV !== 'production') return;

  const GA_ID = process.env.GA_ID || 'G-KTEK0B0DJW';
  if (typeof window['gtag'] === 'function') {
    window['gtag']('config', GA_ID, {
      page_path: location.pathname + (location.search || ''),
    });
  }
};
